__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-27-1787814407-stable-dev/";